import React, { Component } from "react";
import {
    Row,
    Col,
    Select,
    Card,
    Modal,
    InputNumber,
    Input,
    Switch,
    Upload,
    message,
    Icon,
    DatePicker,
    Button,
    Spin,
    Typography,
} from "antd";
import moment from "moment";
import PromoFlyer from "./PromoFlyer.jsx";
import axios from "axios";
import { connect } from "react-redux";
import mpt from "../../../media/mpt.png";
import pst from "../../../media/pst.png";
import flyer from "../../../media/flyer-promo.png";
import ip from "../../../media/information-promotion.png";

import {
    handleUpdate,
    deleteBanner,
    publishBanner,
    unpublishBanner,
    bannerPromoUpdation,
    bannerPromoDeletion,
    addBannerPromo,
    publishPromo,
    unpublishPromo,
} from "../../../actions/dealsHubAdmin";

import "./generic-banner.scss";
import "./generic-banner-listing-component.scss";

import isDev from "../../../server";
import EditorBox from "../../../components/EditorBox/EditorBox";
import { map } from "lodash";
// import CustomEditor from "./CustomEditor";

const serverUrl = isDev();
const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
// const SpinerLoader = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class GenericBannerModalContent extends Component {
    rangePickerDateFormat = "YYYY-MM-DD HH:mm:ss";

    // rangePickerDateFormat = "DD/MM/YYYY HH:mm";

    constructor(props) {
        super(props);
        this.state = {
            createPromoState: false,
            spinnerLoading: false,
            isDeleteOn: false,
            promotionStartDate: null,
            promotionEndDate: null,
            promoUuid: "",
            promoTitle: "",
            promoType: "",
            isPromoPublished: false,
            promoDescription: "",
            promoCost: 0,
            promoAmount: 0,
            promoCohortList: [],
            promoInnerImage: [],
            promoOuterImage: [],
            cohortsList: null,
            promoName: "",
            productArticleId: "",
            minimumPurchaseAmount: 0,
            unitOfMeasure: "",
            uploadingInProgress: false,
            previewVisible: false,
            previewImage: "",
            publishBannerBeforeAddition: false,
            showContent: false,
            isDeleteModalActive: false,
            type: "",
            //promoDescriptionCount: 0
        };
    }

    componentDidMount = () => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/cohort/fetch-cohort-admin-list/`,
                        {
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200 || response.status === 200) {
                            this.setState(
                                {
                                    promoUuid: this.props.bannerPromoData.uuid,
                                    promoTitle: this.props.bannerPromoData.title,
                                    promoType: this.props.promoTypes.find(
                                        (item) => item.name === this.props.bannerPromoData.type
                                    )?.key,
                                    type: this.props.bannerPromoData.type,
                                    // isPromoPublished: this.props.toggleStateFromParent,
                                    isPromoPublished: this.props.bannerPromoData.is_published,
                                    promoDescription: this.props.bannerPromoData.description,
                                    cohortsList: response.data.cohort_list,
                                    promoCost: this.props.bannerPromoData.cost,
                                    promoAmount: this.props.bannerPromoData.amount,
                                    promoCohortList: this.props.bannerPromoData.cohort_list,
                                    promoInnerImage: this.props.bannerPromoData.inner_image,
                                    promoOuterImage: this.props.bannerPromoData.outer_image,
                                    promotionStartDate: this.props.bannerPromoData.start_time,
                                    promotionEndDate: this.props.bannerPromoData.end_time,
                                    // promotionStartDate: this.props.bannerPromoData.start_time ?
                                    //     this.props.bannerPromoData.start_time.replace(/\-/g, "/") :
                                    //     null,
                                    // promotionEndDate: this.props.bannerPromoData.end_time ?
                                    //     this.props.bannerPromoData.end_time.replace(/\-/g, "/") :
                                    //     null,
                                    productArticleId: this.props.bannerPromoData.item_code,
                                    minimumPurchaseAmount: this.props.bannerPromoData.trigger_amount,
                                    unitOfMeasure: this.props.bannerPromoData.uom,
                                    spinnerLoading: false,
                                    isPromoBuffer: this.props.bannerPromoData.isBuffer || false,
                                    createPromoState: !this.props.bannerPromoData.isBuffer,
                                },
                                () => {
                                    if (!this.state.isPromoBuffer) {
                                        this.setPromoName();
                                    } else {
                                        this.setState({
                                            promoName: this.props.promoTypes[0].value,
                                        });
                                    }
                                }
                            );
                        } else if (response.data.status === 403 || response.status === 403) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong while fetching Cohorts List!");
                        }
                    });
            }
        );
    };

    getFinalCohortsArray = () => {
        let temp = [];
        for (let item in this.state.cohortsList) {
            if (this.state.promoCohortList.includes(this.state.cohortsList[item].uuid)) {
                temp.push(this.state.cohortsList[item]);
            }
            // this.state.promoCohortList.map(pair => { return pair.uuid }),
        }
        this.setState({
            promoCohortList: temp,
            spinnerLoading: false,
        });
    };

    setPromoName = () => {
        if (this.state.promoType) {
            for (let index in this.props.promoTypes) {
                if (this.props.promoTypes[index].key === this.state.promoType) {
                    this.setState({
                        promoName: this.props.promoTypes[index].value,
                    });
                    break;
                }
            }
        } else if (this.state.promoType === 0) {
            this.setState({
                promoName: this.props.promoTypes[0].value,
            });
        } else {
            this.setState({
                promoName: this.props.promoTypes[3].value,
            });
        }
    };

    changePromoTypeVariables = (finalVariableType, finalVariablevalue) =>
        this.setState(
            {
                [finalVariableType]: finalVariablevalue,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    getUpdatedPromoObj = () => {
        return {
            uuid: this.state.promoUuid,
            title: this.state.promoTitle,
            type: this.state.type,
            promotion_type: this.state.promoType,
            description: this.state.promoDescription,
            cost: this.state.promoCost,
            amount: this.state.promoAmount,
            cohort_list: this.state.promoCohortList,
            inner_image: this.state.promoInnerImage,
            is_published: this.state.isPromoPublished,
            outer_image: this.state.promoOuterImage,
            section_uuid: this.props.bannerData.uuid,
            // "start_time": this.newFormatDate(this.state.promotionStartDate),
            // "end_time": this.newFormatDate(this.state.promotionEndDate),
            start_time: this.props.convertDateBeforeSending(this.state.promotionStartDate),
            end_time: this.props.convertDateBeforeSending(this.state.promotionEndDate),
            item_code: this.state.productArticleId.toString(),
            trigger_amount: this.state.minimumPurchaseAmount,
            uom: this.state.unitOfMeasure.toString(),
            isBuffer: this.state.isPromoBuffer,
        };
    };

    changeUOMValue = (uomValue) =>
        this.setState(
            {
                unitOfMeasure: uomValue,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    addPromo = () => {
        if (this.state.promoTitle === null || this.state.promoTitle === "") {
            message.error("Please enter Promotion Title ");
        } else if (this.state.promoDescription === null || this.state.promoDescription === "") {
            message.error("Please enter Promotion Description ");
        }else if (
            this.state.promoOuterImage === null ||
            this.state.promoOuterImage.length === 0
        ) {
            message.error("Please Upload Promotion Image");
        } else if (
            this.state.promotionStartDate === null ||
            this.state.promotionStartDate === "" ||
            this.state.promotionEndDate === null ||
            this.state.promotionEndDate === ""
        ) {
            message.error("Please enter Start and End Date of Promotion ");
        } else {
            this.setState(
                {
                    createPromoState: true,
                    spinnerLoading: true,
                    isPromoBuffer: false,
                },
                () => {
                    let bannerPromoObj = this.getUpdatedPromoObj();
                    let formData = new FormData();

                    formData.append("uuid", bannerPromoObj.uuid);
                    formData.append("title", bannerPromoObj.title);
                    formData.append("type", bannerPromoObj.type);
                    // formData.append("promotion_type", bannerPromoObj.promotion_type);
                    formData.append("description", bannerPromoObj.description);
                    formData.append("cost", bannerPromoObj.cost);
                    formData.append("amount", bannerPromoObj.amount);
                    formData.append(
                        "cohort_list",
                        JSON.stringify(bannerPromoObj.cohort_list?.map((item) => item.uuid))
                    );
                    formData.append(
                        "inner_image",
                        bannerPromoObj.inner_image.length > 0
                            ? bannerPromoObj.inner_image[0].originFileObj
                            : bannerPromoObj.inner_image
                    );
                    formData.append(
                        "outer_image",
                        bannerPromoObj.outer_image.length > 0
                            ? bannerPromoObj.outer_image[0].originFileObj
                            : bannerPromoObj.outer_image
                    );
                    formData.append("section_uuid", bannerPromoObj.section_uuid);
                    // formData.append("start_time", bannerPromoObj.start_time ? bannerPromoObj.start_time : "");
                    // formData.append("end_time", bannerPromoObj.end_time ? bannerPromoObj.end_time : "");
                    if (bannerPromoObj.start_time && bannerPromoObj.end_time) {
                        formData.append("start_time", this.props.convertDateBeforeSending(bannerPromoObj.start_time));
                        formData.append("end_time", this.props.convertDateBeforeSending(bannerPromoObj.end_time));
                    }
                    formData.append("item_code", bannerPromoObj.item_code);
                    formData.append("trigger_amount", bannerPromoObj.trigger_amount);
                    formData.append("uom", bannerPromoObj.uom);
                    formData.append("isBuffer", bannerPromoObj.isBuffer);
                    formData.append("permission_category",JSON.stringify(["STORE_CONTROL_CENTER"]));
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/promotion/create-promotion/`,
                            formData,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200 || response.data.status === 201) {
                                message.success("Promotion Added Successfully!");
                                bannerPromoObj["uuid"] = response.data.uuid;
                                if (response.data.inner_image) {
                                    bannerPromoObj.inner_image = [
                                        {
                                            name: "promotion's inner image",
                                            status: "done",
                                            uid: response.data.inner_image.uuid,
                                            url: response.data.inner_image.url,
                                        },
                                    ];
                                }
                                if (response.data.outer_image) {
                                    bannerPromoObj.outer_image = [
                                        {
                                            name: "promotion's outer image",
                                            status: "done",
                                            uid: response.data.outer_image.uuid,
                                            url: response.data.outer_image.url,
                                        },
                                    ];
                                }
                                this.props.addBannerPromo(bannerPromoObj);
                                this.props.updateNewDataInParent(bannerPromoObj);
                                this.setState(
                                    {
                                        spinnerLoading: false,
                                        promoUuid: response.data.uuid,
                                        promoOuterImage: bannerPromoObj.outer_image,
                                        promoInnerImage: bannerPromoObj.inner_image,
                                    },
                                    () => {
                                        if (this.state.publishBannerBeforeAddition) {
                                            this.setState(
                                                {
                                                    publishBannerBeforeAddition: false,
                                                },
                                                () => {
                                                    this.togglePublishBanner(
                                                        !this.state.isPromoPublished,
                                                        this.props.bannerData.uuid,
                                                        this.state.promoUuid,
                                                        this.props.promoClickedIndex
                                                    );
                                                }
                                            );
                                        }
                                        // :this.updatePromotionData();
                                    }
                                );
                                this.props.fetchInitialData();
                                this.props.handleclosemodal();
                            } else if (response.data.status === 403) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went wrong!");
                            }
                        });
                }
            );
        }
    };

    newFormatDate = (dateString) => {
        if (dateString) {
            let a = dateString.indexOf("Z");
            let b = dateString.replace(/\//g, "-");
            let n = [b.slice(0, a), ":00", b.slice(a)].join("");
            return n;
        }
    };

    updatePromotionData = () => {
        if (this.state.promoTitle === null || this.state.promoTitle === "") {
            message.error("Please enter Promotion Title ");
        } else if (this.state.promoDescription === null || this.state.promoDescription === "") {
            message.error("Please enter Promotion Description ");
        }else if (
            this.state.promoOuterImage === null ||
            this.state.promoOuterImage.length === 0
        ) {
            message.error("Please Upload Promotion Image");
        } else if (
            this.state.promotionStartDate === null ||
            this.state.promotionStartDate === "" ||
            this.state.promotionEndDate === null ||
            this.state.promotionEndDate === ""
        ) {
            message.error("Please enter Start and End Date of Promotion ");
        } else {
            this.setState(
                {
                    spinnerLoading: true,
                },
                () => {
                    let finalPromoObj = this.getUpdatedPromoObj();
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/promotion/update-promotion/`,
                            {
                                uuid: this.state.promoUuid,
                                title: this.state.promoTitle,
                                description: this.state.promoDescription,
                                cost: this.state.promoCost,
                                amount: this.state.promoAmount,
                                cohort_list: this.state.promoCohortList.map((e) => e.uuid),
                                // "start_time": this.newFormatDate(this.state.promotionStartDate),
                                // "end_time": this.newFormatDate(this.state.promotionEndDate),
                                start_time: this.props.convertDateBeforeSending(this.state.promotionStartDate),
                                end_time: this.props.convertDateBeforeSending(this.state.promotionEndDate),
                                // promotion_type: this.state.promoType,
                                type: this.state.type,
                                item_code: this.state.productArticleId.toString(),
                                trigger_amount: this.state.minimumPurchaseAmount,
                                uom: this.state.unitOfMeasure.toString(),
                                permission_category:["STORE_CONTROL_CENTER"]
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200) {
                                message.success("Draft Saved Successfully!");
                                this.props.bannerPromoUpdation({
                                    section_uuid: this.props.bannerData.uuid,
                                    promoObj: finalPromoObj,
                                });
                                this.props.updateNewDataInParent(finalPromoObj);
                                this.setState({
                                    spinnerLoading: false,
                                });
                            } else if (response.data.status === 403) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went wrong!");
                            }
                        });
                }
            );
        }
    };

    handleCancel = () => this.setState({ previewVisible: false });

    publishPromoBtn = (bannerUuid, promoUuid, i) => {
        axios
            .post(
                `${serverUrl}/${
                    JSON.parse(localStorage.getItem("countryData")).database_identifier
                }/promotion/update-promotion/`,
                {
                    uuid: promoUuid,
                    is_published: "true",
                    permission_category:["STORE_CONTROL_CENTER"]
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `JWT ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((response) => {
                if (response.data.status === 200) {
                    message.success("Published Successfully!");
                    this.props.publishPromo(bannerUuid, promoUuid);
                    this.setState({
                        spinnerLoading: false,
                    });
                } else if (response.data.status === 403) {
                    message.info("You are not authorised!");
                } else {
                    message.error("Something went wrong!");
                }
            });
    };

    unpublishPromoBtn = (bannerUuid, promoUuid, i) => {
        axios
            .post(
                `${serverUrl}/${
                    JSON.parse(localStorage.getItem("countryData")).database_identifier
                }/promotion/update-promotion/`,
                {
                    uuid: promoUuid,
                    is_published: false,
                    permission_category:["STORE_CONTROL_CENTER"]
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `JWT ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((response) => {
                if (response.data.status === 200) {
                    message.success("Unpublished Successfully!");
                    this.props.unpublishPromo(bannerUuid, promoUuid);
                    this.setState({
                        spinnerLoading: false,
                    });
                } else if (response.data.status === 403) {
                    message.info("You are not authorised!");
                } else {
                    message.error("Something went wrong!");
                }
            });
    };

    togglePublishBanner = (checked, bannerUuid, promoUuid, i) => {
        this.setState(
            {
                spinnerLoading: true,
                isPromoPublished: checked,
            },
            () => {
                this.props.bannerPromoUpdation({
                    section_uuid: this.props.bannerData.uuid,
                    promoObj: {
                        uuid: this.state.promoUuid,
                    },
                    isPublishToggled: checked,
                });
                !checked
                    ? this.unpublishPromoBtn(bannerUuid, promoUuid, i)
                    : this.publishPromoBtn(bannerUuid, promoUuid, i);
            }
        );
    };

    updateName = (newName) =>
        this.setState(
            {
                promoTitle: newName,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    validateAmountAndCost = () => {
        if (typeof this.state.promoCost === "number" && typeof this.state.promoAmount === "number") return true;
        else {
            message.info("Only numbers allowed in COST and AMOUNT fields");
            return false;
        }
    };

    updatePromoCost = (updatedCost) =>
        this.setState(
            {
                promoCost: updatedCost,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    updatePromoAmount = (updatedAmount) =>
        this.setState(
            {
                promoAmount: updatedAmount,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    changeTime = (str, time) => {
        let tempArr = str.split(" ");
        tempArr[1] = time;
        return tempArr.join(" ");
    };

    changePromotionRange = (dateRangeMoment, dateRangeStrings) => {
        
        dateRangeStrings[0] = moment(dateRangeStrings[0], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        dateRangeStrings[1] = moment(dateRangeStrings[1], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");

        this.setState(
            {
                promotionStartDate:
                    dateRangeStrings[0] === "" ? null : dateRangeStrings[0].replace(" ", "T").concat("Z"),
                promotionEndDate: dateRangeStrings[1] === "" ? null : dateRangeStrings[1].replace(" ", "T").concat("Z"),
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );


    };

    updateCohortsList = (selectedCohortsArray) =>
        this.setState(
            {
                promoCohortList: selectedCohortsArray,
            },
            () => {
                this.props.updateNewDataInParent(this.getUpdatedPromoObj());
            }
        );

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    getEditorText = (e) => {
        this.setState({
            promoDescription: e,
        });
    };

    // getCount = (e) => {
    //     this.setState({
    //         promoDescriptionCount: e
    //     })
    // }

    beforeInnerImageUpload = (file) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        return isJpgOrPng && isLt2M;
    };

    beforeOuterImageUpload = (file) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        return isJpgOrPng && isLt2M;
    };

    handleInnerImageChange = ({ fileList }) => {
        if (fileList.length > 0 && !this.state.uploadingInProgress && !this.state.isDeleteOn) {
            this.setState(
                {
                    uploadingInProgress: true,
                },
                () => {
                    let currentImage = fileList[fileList.length - 1];
                    let formData = new FormData();
                    formData.append("image", currentImage.originFileObj);
                    formData.append("image_type", "inner");
                    formData.append("uuid", this.state.promoUuid);
                    formData.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));

                    if (currentImage.originFileObj !== undefined && !this.state.isPromoBuffer) {
                        axios
                            .post(
                                `${serverUrl}/${
                                    JSON.parse(localStorage.getItem("countryData")).database_identifier
                                }/promotion/upload-promotion-image/`,
                                formData,
                                {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        Authorization: `JWT ${localStorage.getItem("token")}`,
                                    },
                                }
                            )
                            .then((response) => {
                                this.setState(
                                    {
                                        uploadingInProgress: false,
                                        spinnerLoading: false,
                                        isDeleteOn: false,
                                        promoInnerImage: [
                                            {
                                                name: `${this.props.bannerPromoData.title}'s inner image`,
                                                status: "done",
                                                uid: response.data.uuid,
                                                url: response.data.url,
                                            },
                                        ],
                                    },
                                    () => {
                                        this.props.bannerPromoUpdation({
                                            section_uuid: this.props.bannerData.uuid,
                                            promoObj: this.getUpdatedPromoObj(),
                                        });
                                        message.success("Promo Inner Image Uploaded Successfully!");
                                    }
                                );
                            });
                    } else {
                        this.setState({
                            uploadingInProgress: false,
                            spinnerLoading: false,
                            isDeleteOn: false,
                            promoInnerImage: [currentImage],
                        });
                    }
                }
            );
        }
    };

    handleOuterImageChange = ({ fileList }) => {
        if (fileList.length > 0 && !this.state.uploadingInProgress && !this.state.isDeleteOn) {
            this.setState(
                {
                    uploadingInProgress: true,
                },
                () => {
                    let currentImage = fileList[fileList.length - 1];
                    let formData = new FormData();
                    formData.append("image", currentImage.originFileObj);
                    formData.append("image_type", "outer");
                    formData.append("uuid", this.state.promoUuid);
                    formData.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));

                    if (currentImage.originFileObj !== undefined && !this.state.isPromoBuffer) {
                        axios
                            .post(
                                `${serverUrl}/${
                                    JSON.parse(localStorage.getItem("countryData")).database_identifier
                                }/promotion/upload-promotion-image/`,
                                formData,
                                {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        Authorization: `JWT ${localStorage.getItem("token")}`,
                                    },
                                }
                            )
                            .then((response) => {
                                this.setState(
                                    {
                                        uploadingInProgress: false,
                                        spinnerLoading: false,
                                        isDeleteOn: false,
                                        promoOuterImage: [
                                            {
                                                name: `${this.props.bannerPromoData.title}'s Outer image`,
                                                status: "done",
                                                uid: response.data.uuid,
                                                url: response.data.url,
                                            },
                                        ],
                                    },
                                    () => {
                                        this.props.bannerPromoUpdation({
                                            section_uuid: this.props.bannerData.uuid,
                                            promoObj: this.getUpdatedPromoObj(),
                                        });
                                        message.success("Promo Outer Image Uploaded Successfully!");
                                    }
                                );
                            });
                    } else {
                        this.setState({
                            uploadingInProgress: false,
                            spinnerLoading: false,
                            isDeleteOn: false,
                            promoOuterImage: [currentImage],
                        });
                    }
                }
            );
        }
    };

    dummyInnerImageRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    dummyOuterImageRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    handleInnerImagePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleOuterImagePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    removeOuterImageFile = (file) => {
        this.setState(
            {
                isDeleteOn: true,
                spinnerLoading: true,
            },
            () => {
                if (!this.state.isPromoBuffer) {
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/promotion/remove-promotion-image/`,
                            {
                                uuid: this.state.promoOuterImage[0].uid,
                                permission_category:["STORE_CONTROL_CENTER"]
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200) {
                                this.setState(
                                    {
                                        spinnerLoading: false,
                                        isDeleteOn: false,
                                        promoOuterImage: [],
                                    },
                                    () => {
                                        this.props.bannerPromoUpdation({
                                            section_uuid: this.props.bannerData.uuid,
                                            promoObj: this.getUpdatedPromoObj(),
                                        });
                                    }
                                );
                                message.success("Promo Image Deleted Successfully!");
                            } else if (response.data.status === 405) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went Wrong!");
                            }
                        });
                } else {
                    this.setState({
                        spinnerLoading: false,
                        isDeleteOn: false,
                        promoOuterImage: [],
                    });
                }
            }
        );
    };

    getDefaultUnitOfMeasure = () => {
        return (
            this.props.uomObject.filter((item) => item.key === this.state.unitOfMeasure)[0]?.value +
            "&" +
            this.state.unitOfMeasure
        );
    };

    removeInnerImageFile = (file) => {
        this.setState(
            {
                isDeleteOn: true,
                spinnerLoading: true,
            },
            () => {
                if (!file.uid.includes("rc-")) {
                    axios
                        .post(
                            `${serverUrl}/${
                                JSON.parse(localStorage.getItem("countryData")).database_identifier
                            }/promotion/remove-promotion-image/`,
                            {
                                uuid: file.uid,
                                permission_category:["STORE_CONTROL_CENTER"]
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `JWT ${localStorage.getItem("token")}`,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.status === 200) {
                                this.setState(
                                    {
                                        spinnerLoading: false,
                                        isDeleteOn: false,
                                        promoInnerImage: [],
                                    },
                                    () => {
                                        this.props.bannerPromoUpdation({
                                            section_uuid: this.props.bannerData.uuid,
                                            promoObj: this.getUpdatedPromoObj(),
                                        });
                                    }
                                );
                                message.success("Promo Image Deleted Successfully!");
                            } else if (response.data.status === 405) {
                                message.info("You are not authorised!");
                            } else {
                                message.error("Something went Wrong!");
                            }
                        });
                } else {
                    this.setState({
                        spinnerLoading: false,
                        isDeleteOn: false,
                        promoInnerImage: [],
                    });
                }
            }
        );
    };

    getNewPromoFlyerObj = () => {
        return {
            uuid: "",
            title: "New Promotion Flyer",
            promotion_type: this.props.promoTypes[3].key,
            type: "flyer",
            description: "",
            store_list: [],
            is_published: false,
            inner_image: [],
            outer_image: [],
            section_uuid: this.props.bannerData.uuid,
            start_time: null,
            end_time: null,
            isBuffer: true,
        };
    };

    setPromoBufferFalse = () => this.setState({ isPromoBuffer: false });

    openDeleteModal = () => this.setState({ isDeleteModalActive: true });

    closeDeleteModal = () => this.setState({ isDeleteModalActive: false });

    render() {
        if (!this.state.spinnerLoading) {
            return (
                <>
                    {this.state.isPromoBuffer && !this.state.showContent && (
                        <Row>
                            <Row className={"modal-row"}>
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                        // fontFamily: 'Gotham'
                                    }}>
                                    Select Type of Grid Promotion
                                </Text>
                            </Row>

                            <Row
                                style={{
                                    margin: "24px 0px 0px",
                                }}
                                gutter={[24, 24]}
                                type={"flex"}
                                justify={"space-between"}
                                align={"middle"}>
                                <Col span={24} style={{ padding: "0px" }}>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ padding: "0px 24px 0px 0px" }}>
                                        <div
                                            onClick={() => {
                                                this.setState({
                                                    promoType: this.props.promoTypes[0].key,
                                                    type: this.props.promoTypes[0].name,
                                                });
                                            }}>
                                            <Card
                                                style={{
                                                    cursor: "pointer",
                                                    minHeight: "246px",
                                                    textAlign: "center",
                                                    //minWidth: '250px',
                                                    borderRadius: "10px",
                                                    border:
                                                        this.state.promoType === this.props.promoTypes[0].key
                                                            ? "1px solid #fec708"
                                                            : "1px solid #F2F2F2",
                                                    backgroundColor: " #FFFFFF",
                                                    boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                }}>
                                                <img src={ip} style={{ marginBottom: "16px", width: "100%" }} />
                                                <br />
                                                <Text
                                                    style={{
                                                        color: "#181818",
                                                        fontSize: "16px",
                                                    }}>
                                                    {this.props.promoTypes[0].value}
                                                </Text>
                                            </Card>
                                        </div>
                                    </Col>

                                    {/* <Col xs={24} sm={12} md={12} lg={6} xl={6} style={{ padding: "0px 24px 0px 0px" }}>
                                        <div
                                            onClick={() => {
                                                this.setState({
                                                    promoType: this.props.promoTypes[1].key,
                                                    type: this.props.promoTypes[1].name,
                                                });
                                            }}>
                                            <Card
                                                style={{
                                                    cursor: "pointer",
                                                    minHeight: "246px",
                                                    textAlign: "center",
                                                    //minWidth: '250px',
                                                    borderRadius: "10px",
                                                    border:
                                                        this.state.promoType === this.props.promoTypes[1].key
                                                            ? "1px solid #fec708"
                                                            : "1px solid #F2F2F2",
                                                    boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                }}>
                                                <img src={mpt} style={{ marginBottom: "16px", width: "100%" }} />
                                                <br />
                                                <Text
                                                    style={{
                                                        color: "#181818",
                                                        fontSize: "16px",
                                                    }}>
                                                    {this.props.promoTypes[1].value}
                                                </Text>
                                            </Card>
                                        </div>
                                    </Col>

                                    <Col xs={24} sm={12} md={12} lg={6} xl={6} style={{ padding: "0px 24px 0px 0px" }}>
                                        <div
                                            onClick={() => {
                                                this.setState({
                                                    promoType: this.props.promoTypes[2].key,
                                                    type: this.props.promoTypes[2].name,
                                                });
                                            }}>
                                            <Card
                                                style={{
                                                    cursor: "pointer",
                                                    minHeight: "246px",
                                                    textAlign: "center",
                                                    //minWidth: '250px',
                                                    borderRadius: "10px",
                                                    border:
                                                        this.state.promoType === this.props.promoTypes[2].key
                                                            ? "1px solid #fec708"
                                                            : "1px solid #F2F2F2",
                                                    boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                }}>
                                                <img src={pst} style={{ marginBottom: "16px", width: "100%" }} />
                                                <br />
                                                <Text
                                                    style={{
                                                        color: "#181818",
                                                        fontSize: "16px",
                                                    }}>
                                                    {this.props.promoTypes[2].value}
                                                </Text>
                                            </Card>
                                        </div>
                                    </Col> */}

                                    <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ padding: "0px 24px 0px 0px" }}>
                                        <div
                                            onClick={() => {
                                                this.setState({
                                                    promoType: this.props.promoTypes[3].key,
                                                    type: this.props.promoTypes[3].name,
                                                });
                                            }}>
                                            <Card
                                                style={{
                                                    cursor: "pointer",
                                                    minHeight: "246px",
                                                    textAlign: "center",
                                                    //minWidth: '250px',
                                                    borderRadius: "10px",
                                                    border:
                                                        this.state.promoType === this.props.promoTypes[3].key
                                                            ? "1px solid #fec708"
                                                            : "1px solid #F2F2F2",
                                                    boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                }}>
                                                <img src={flyer} style={{ marginBottom: "16px", width: "100%" }} />
                                                <br />
                                                <Text
                                                    style={{
                                                        color: "#181818",
                                                        fontSize: "16px",
                                                    }}>
                                                    {this.props.promoTypes[3].value}
                                                </Text>
                                            </Card>
                                        </div>
                                    </Col>
                                </Col>

                                <Col span={24} style={{ textAlign: "right", marginTop: "40px", padding: "0px" }}>
                                    <Button
                                        size='large'
                                        disabled={this.state.promoType === null}
                                        style={{
                                            width: "200px",
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: /*this.state.promoType ? "#E8E8E8" :*/ "#fec708",
                                            color: /*this.state.promoType ? "#747474" :*/ "#FFFFFF",
                                        }}
                                        onClick={() => {
                                            // this.setPromoName();
                                            this.setState(
                                                {
                                                    showContent: true,
                                                    // isPromoBuffer: false
                                                },
                                                () => {
                                                    this.setPromoName();
                                                    this.props.promoTypeSelected();
                                                }
                                            );
                                        }}>
                                        Continue
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    )}
                    {(this.state.showContent || !this.state.isPromoBuffer) && this.state.type !== "flyer" && (
                        <Row className='modal-row'>
                            <Row align={"middle"} type={"flex"} justify={"space-between"}>
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                    }}>
                                    <img
                                        alt=''
                                        src={this.state.promoType === 0 ? ip : this.state.promoType === 1 ? mpt : pst}
                                        style={{
                                            height: "40px",
                                            width: "54px",
                                            borderRadius: "5px",
                                            marginRight: "16px",
                                        }}
                                    />
                                    {this.state.createPromoState ? "View " : "Create "}
                                    {this.state.promoName}
                                </Text>
                                <div onClick={(e) => e.stopPropagation()}>
                                    <Col
                                        style={{
                                            borderRight: "1px solid #E8E8E8",
                                            marginRight: "48px",
                                            marginTop: "-5px",
                                        }}>
                                        <Switch
                                            //disabled={!(this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0)}
                                            // defaultChecked={this.state.toggleStateFromParent}
                                            // checked={this.props.toggleStateFromParent}
                                            checked={this.state.isPromoPublished}
                                            onChange={(checked) => {
                                                // if (this.state.isPromoBuffer) {
                                                this.setState(
                                                    {
                                                        publishBannerBeforeAddition: true,
                                                    },
                                                    () => {
                                                        if (
                                                            this.state.isPromoBuffer &&
                                                            this.state.publishBannerBeforeAddition
                                                        ) {
                                                            this.addPromo();
                                                        } else {
                                                            this.togglePublishBanner(
                                                                checked,
                                                                this.props.bannerData.uuid,
                                                                this.state.promoUuid,
                                                                this.props.promoClickedIndex
                                                            );
                                                        }
                                                    }
                                                );
                                                // }
                                                // :this.togglePublishBanner(checked);
                                            }}
                                            // style={{ marginRight: "24px" }}
                                        />
                                    </Col>
                                </div>
                                {/*<Divider type={"vertical"}/>*/}
                            </Row>
                            <Row
                                style={{
                                    marginTop: "30px",
                                }}>
                                <Col span={24}>
                                    <Col
                                        span={13}
                                        style={{
                                            // marginRight: '20px',
                                            borderRadius: "10px",
                                            border: "1px solid #E8E8E8",
                                        }}>
                                        <Col
                                            span={24}
                                            style={{
                                                padding: "20px",
                                                borderBottom: "1px solid #E8E8E8",
                                            }}>
                                            <Col span={24}>
                                                <Row type={"flex"} justify={"space-between"}>
                                                    <Text
                                                        style={{
                                                            fontSize: "14px",
                                                            color: "#181818",
                                                            fontWeight: "bold",
                                                        }}>
                                                        Promotion Title <span style={{color:"red"}}>*</span>
                                                    </Text>
                                                    {/*<Text style={{*/}
                                                    {/*    fontSize: '12px',*/}
                                                    {/*    color: '#747474'*/}
                                                    {/*}}>{this.state.promoTitle.length}/65</Text>*/}
                                                </Row>
                                                <Row>
                                                    <Input
                                                        style={{
                                                            backgroundColor: "#FFFFFF",
                                                            border: "1px solid #D9D9D9",
                                                            borderRadius: "5px",
                                                            marginTop: "8px",
                                                        }}
                                                        placeholder={"Eg. - Mid Week deals"}
                                                        value={this.state.promoTitle}
                                                        onChange={(e) => {
                                                            this.updateName(e.target.value);
                                                        }}
                                                        maxLength={65}
                                                    />
                                                </Row>
                                            </Col>
                                            <Col
                                                span={24}
                                                style={{
                                                    marginBottom: "44px",
                                                    marginTop: "24px",
                                                }}>
                                                <Row type={"flex"} justify={"space-between"}>
                                                    <Text
                                                        style={{
                                                            fontSize: "14px",
                                                            color: "#181818",
                                                            fontWeight: "bold",
                                                        }}>
                                                        Promotion Description <span style={{color:"red"}}>*</span>
                                                    </Text>
                                                    {/*<Text style={{*/}
                                                    {/*    fontSize: '12px',*/}
                                                    {/*    color: '#747474'*/}
                                                    {/*}}>{this.state.promoDescriptionCount}/178</Text>*/}
                                                </Row>
                                                <Row>
                                                    <EditorBox
                                                        //maxLength={177}
                                                        GenericBannerModal={true}
                                                        height='200px'
                                                        value={this.state.promoDescription}
                                                        getText={this.getEditorText}
                                                        style={{ borderRadius: "5px" }}
                                                        //getCount={this.getCount}
                                                    />
                                                </Row>
                                            </Col>
                                        </Col>

                                        <Col
                                            span={24}
                                            style={{
                                                padding: "20px",
                                                // borderBottom: '1px solid #E8E8E8'
                                            }}>
                                            {/*<Text>Upload Front Images</Text>*/}
                                            {/*<br/>*/}
                                            {/*<Text>Allowed image format is JPG, JPEG, PNG and size 180x140 upto 20KB - 40KB</Text>*/}
                                            <Row className='image-upload-row'>
                                                {/*//this.state.promoUuid != "" &&*/}
                                                <React.Fragment>
                                                    <Col span={24} className='image-upload-col'>
                                                        <Text
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#181818",
                                                                fontWeight: "bold",
                                                            }}>
                                                            Upload Promo Image <span style={{color:"red"}}>*</span>
                                                        </Text>
                                                        <br />
                                                        <Text style={{ fontSize: "12px" }}>
                                                            Allowed image format is JPG, JPEG, PNG and size 180x140 upto
                                                            20KB - 40KB
                                                        </Text>
                                                        <div
                                                            style={{
                                                                borderRadius: "5px",
                                                                width: "100%",
                                                                border: `${
                                                                    this.state.promoOuterImage.length > 0
                                                                        ? "none"
                                                                        : "1px dashed #C4C4C4"
                                                                }`,
                                                            }}
                                                            className='image-upload-container'>
                                                            <Upload
                                                                showUploadList={{ showPreviewIcon: false }}
                                                                listType='picture-card'
                                                                // showUploadList={false}
                                                                style={{
                                                                    height: "150px",
                                                                    width: "100%",
                                                                }}
                                                                beforeUpload={this.beforeOuterImageUpload}
                                                                onChange={this.handleOuterImageChange}
                                                                onPreview={this.handleOuterImagePreview}
                                                                onRemove={this.removeOuterImageFile}
                                                                customRequest={this.dummyOuterImageRequest}
                                                                fileList={this.state.promoOuterImage}>
                                                                {this.state.promoOuterImage?.length > 0 ? null : (
                                                                    <>
                                                                        <p
                                                                            className='ant-upload-drag-icon'
                                                                            style={{ marginTop: "30px" }}>
                                                                            <Icon
                                                                                type='cloud-upload'
                                                                                style={{ fontSize: "24px" }}
                                                                            />
                                                                        </p>
                                                                        <p className='ant-upload-text'>
                                                                            Drag and drop or upload Images
                                                                        </p>
                                                                    </>
                                                                )}
                                                            </Upload>
                                                        </div>
                                                    </Col>
                                                    <Col span={24} className='image-upload-col'>
                                                        <Col span={24} style={{ marginTop: "18px" }}>
                                                            {" "}
                                                        </Col>
                                                        <Text
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#181818",
                                                                fontWeight: "bold",
                                                                marginTop: "24px",
                                                            }}>
                                                            Upload Banner Image
                                                        </Text>
                                                        <br />
                                                        <Text style={{ fontSize: "12px" }}>
                                                            Allowed image format is JPG, JPEG, PNG and size 280x140 upto
                                                            20KB - 40KB
                                                        </Text>
                                                        <div
                                                            style={{
                                                                borderRadius: "5px",
                                                                width: "100%",
                                                                border: `${
                                                                    this.state.promoInnerImage.length > 0
                                                                        ? "none"
                                                                        : "1px dashed #C4C4C4"
                                                                }`,
                                                            }}
                                                            className='image-upload-container'>
                                                            <Upload
                                                                showUploadList={{ showPreviewIcon: false }}
                                                                listType='picture-card'
                                                                // showUploadList={false}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "150px",
                                                                }}
                                                                beforeUpload={this.beforeInnerImageUpload}
                                                                onChange={this.handleInnerImageChange}
                                                                onPreview={this.handleInnerImagePreview}
                                                                onRemove={this.removeInnerImageFile}
                                                                customRequest={this.dummyInnerImageRequest}
                                                                fileList={this.state.promoInnerImage}>
                                                                {this.state.promoInnerImage.length > 0 ? null : (
                                                                    <>
                                                                        <p
                                                                            className='ant-upload-drag-icon'
                                                                            style={{ marginTop: "30px" }}>
                                                                            <Icon
                                                                                type='cloud-upload'
                                                                                style={{ fontSize: "24px" }}
                                                                            />
                                                                        </p>
                                                                        <p className='ant-upload-text'>
                                                                            Drag and drop or upload Images
                                                                        </p>
                                                                    </>
                                                                )}
                                                            </Upload>
                                                        </div>
                                                    </Col>
                                                </React.Fragment>
                                            </Row>
                                        </Col>
                                    </Col>

                                    <Col span={11} style={{ paddingLeft: "20px" }}>
                                        <Col
                                            style={{
                                                minHeight: "930px",
                                                borderRadius: "10px",
                                                border: "1px solid #E8E8E8",
                                            }}>
                                            <Col
                                                span={24}
                                                style={{
                                                    padding: "20px",
                                                    borderBottom: "1px solid #E8E8E8",
                                                }}>
                                                <Col span={24}>
                                                    <Text
                                                        style={{
                                                            fontSize: "14px",
                                                            color: "#181818",
                                                            fontWeight: "bold",
                                                        }}>
                                                        Start - End Date <span style={{color:"red"}}>*</span>
                                                    </Text>
                                                    <br />
                                                    <RangePicker
                                                        className='time-value-cohort-col-main-element'
                                                        defaultValue={
                                                            this.state.promotionStartDate
                                                                ? [
                                                                      moment(
                                                                          this.state.promotionStartDate,
                                                                          this.rangePickerDateFormat
                                                                      ),
                                                                      moment(
                                                                          this.state.promotionEndDate,
                                                                          this.rangePickerDateFormat
                                                                      ),
                                                                  ]
                                                                : null
                                                        }
                                                        showTime={{ format: "HH:mm:ss" }}
                                                        format={"DD-MM-YYYY HH:mm:ss"}
                                                        placeholder={["Start Time", "End Time"]}
                                                        onOk={() => {}}
                                                        onChange={this.changePromotionRange}
                                                    />
                                                </Col>
                                            </Col>
                                            {!(this.state.promoType === 0 || this.state.promoType === "0") && (
                                                <Col
                                                    span={24}
                                                    style={{
                                                        padding: "20px",
                                                        borderBottom: "1px solid #E8E8E8",
                                                    }}>
                                                    <Col span={24}>
                                                        <Text
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#181818",
                                                                fontWeight: "bold",
                                                            }}>
                                                            Promo Cost (Points)
                                                        </Text>
                                                        <InputNumber
                                                            maxLength={50}
                                                            placeholder={"Eg. - 500 Points"}
                                                            defaultValue={this.state.promoCost}
                                                            className='time-value-cohort-col-main-element'
                                                            onChange={this.updatePromoCost}
                                                            // style={{
                                                            //     background: '#fff',
                                                            //     border: '1px solid #D9D9D9',
                                                            //     borderRadius: '2px',
                                                            //     width: '100%'
                                                            // }}
                                                        />
                                                    </Col>
                                                    <Col span={24} style={{ marginTop: "24px" }}>
                                                        <Text
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#181818",
                                                                fontWeight: "bold",
                                                            }}>
                                                            {this.state.promoType === 2 || this.state.promoType === "2"
                                                                ? `Final Amount (${
                                                                      JSON.parse(localStorage.getItem("countryData"))
                                                                          ?.currency
                                                                  })`
                                                                : `Promo Amount (${
                                                                      JSON.parse(localStorage.getItem("countryData"))
                                                                          ?.currency
                                                                  })`}
                                                        </Text>
                                                        <InputNumber
                                                            maxLength={50}
                                                            defaultValue={this.state.promoAmount}
                                                            className='time-value-cohort-col-main-element'
                                                            onChange={this.updatePromoAmount}
                                                        />
                                                    </Col>
                                                </Col>
                                            )}

                                            <Col
                                                span={24}
                                                style={{
                                                    padding: "20px",
                                                    // borderBottom: '1px solid #E8E8E8'
                                                }}>
                                                <Row
                                                //className="time-value-cohort-row"
                                                >
                                                    <Col span={24}>
                                                        <Text
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#181818",
                                                                fontWeight: "bold",
                                                            }}>
                                                            Select Cohort
                                                        </Text>
                                                        <Select
                                                            mode='multiple'
                                                            style={{ width: "100%" }}
                                                            placeholder='Eg. - Cohort 1'
                                                            className='time-value-cohort-col-main-element'
                                                            value={this.state.promoCohortList?.map((item) => {
                                                                return item.uuid;
                                                            })}
                                                            onChange={(e) => {
                                                                let cohortList = e.map((uuid) => {
                                                                    for (
                                                                        let i = 0;
                                                                        i < this.state.cohortsList.length;
                                                                        i++
                                                                    ) {
                                                                        if (this.state.cohortsList[i].uuid === uuid)
                                                                            return this.state.cohortsList[i];
                                                                    }
                                                                });
                                                                this.updateCohortsList(cohortList);
                                                            }}
                                                            optionLabelProp='label'>
                                                            {this.state.cohortsList &&
                                                                this.state.cohortsList.map((cohortItem) => {
                                                                    return (
                                                                        <Option
                                                                            value={cohortItem.uuid}
                                                                            key={cohortItem.uuid}
                                                                            label={cohortItem.name}>
                                                                            {cohortItem.name}
                                                                        </Option>
                                                                    );
                                                                })}
                                                        </Select>
                                                    </Col>
                                                    {this.state.promoType === 1 && (
                                                        <Col span={24} style={{ marginTop: "24px" }}>
                                                            <Text
                                                                style={{
                                                                    fontSize: "14px",
                                                                    color: "#181818",
                                                                    fontWeight: "bold",
                                                                }}>
                                                                Minimum Purchase Amount
                                                            </Text>
                                                            <InputNumber
                                                                maxLength={50}
                                                                value={this.state.minimumPurchaseAmount}
                                                                className='time-value-cohort-col-main-element'
                                                                onChange={(value) => {
                                                                    this.changePromoTypeVariables(
                                                                        "minimumPurchaseAmount",
                                                                        value
                                                                    );
                                                                }}
                                                            />
                                                        </Col>
                                                    )}

                                                    {this.state.promoType === 2 && (
                                                        <>
                                                            <Col span={24} style={{ marginTop: "24px" }}>
                                                                <Text
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        color: "#181818",
                                                                        fontWeight: "bold",
                                                                    }}>
                                                                    Product Article ID
                                                                </Text>
                                                                <Input
                                                                    maxLength={50}
                                                                    value={this.state.productArticleId}
                                                                    className='time-value-cohort-col-main-element'
                                                                    onChange={(event) => {
                                                                        this.changePromoTypeVariables(
                                                                            "productArticleId",
                                                                            event.target.value
                                                                        );
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col span={24} style={{ marginTop: "24px" }}>
                                                                <Text
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        color: "#181818",
                                                                        fontWeight: "bold",
                                                                    }}>
                                                                    UoM
                                                                </Text>
                                                                <Select
                                                                    style={{ width: "100%" }}
                                                                    className='time-value-cohort-col-main-element'
                                                                    placeholder='Select UOM'
                                                                    showSearch
                                                                    onChange={(uomValue_uomKey) => {
                                                                        let uomKey = uomValue_uomKey.split("&")[1];
                                                                        this.changeUOMValue(uomKey);
                                                                        // this.state.promoCohortList.map(item => { return item.uuid })

                                                                        // let cohortList = e.map((uuid) => {
                                                                        //     for (let i = 0; i < this.state.cohortsList.length; i++) {
                                                                        //         if (this.state.cohortsList[i].uuid === uuid)
                                                                        //             return this.state.cohortsList[i];
                                                                        //     }
                                                                        // })
                                                                        // this.updateCohortsList(cohortList);
                                                                    }}
                                                                    optionLabelProp='label'>
                                                                    {this.props.uomObject &&
                                                                        this.props.uomObject.map((uomItem) => {
                                                                            return (
                                                                                <Option
                                                                                    value={
                                                                                        `${uomItem.value}&` +
                                                                                        uomItem.key
                                                                                    }
                                                                                    key={uomItem.key}
                                                                                    label={uomItem.value}>
                                                                                    {uomItem.value}
                                                                                </Option>
                                                                            );
                                                                        })}
                                                                </Select>
                                                                {/* <InputNumber
                                                        maxLength={50}
                                                        value={this.state.unitOfMeasure}
                                                        className="time-value-cohort-col-main-element"
                                                        onChange={(value) => {
                                                            this.changePromoTypeVariables("unitOfMeasure", value)
                                                        }}
                                                    /> */}
                                                            </Col>
                                                        </>
                                                    )}
                                                </Row>
                                            </Col>
                                        </Col>
                                    </Col>
                                </Col>
                            </Row>
                            {this.state.createPromoState ? (
                                <Col
                                    span={24}
                                    style={{
                                        marginTop: "40px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <Button
                                        onClick={this.openDeleteModal}
                                        style={{
                                            width: "78px",
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "1px solid #e3102f",
                                            backgroundColor: "#FFFFFF",
                                            color: "#e3102f",
                                        }}>
                                        Delete
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            this.updatePromotionData();
                                        }}
                                        style={{
                                            width: "150px",
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#fec708",
                                            color: "#FFFFFF",
                                        }}>
                                        Save & Update
                                    </Button>
                                </Col>
                            ) : (
                                <Col span={24} style={{ textAlign: "right", marginTop: "40px" }}>
                                    <Button
                                        //disabled={!(this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0)}
                                        onClick={() => {
                                            this.state.isPromoBuffer ? this.addPromo() : this.updatePromotionData();
                                        }}
                                        style={{
                                            width: "106px",
                                            height: "40px",
                                            borderRadius: "5px",
                                            color: "#1890FF",
                                            border: "1px solid #1890FF",
                                            marginRight: "16px",
                                        }}>
                                        Save Draft
                                    </Button>
                                    <Button
                                        //disabled={!(this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0)}
                                        onClick={() => {
                                            this.setState(
                                                {
                                                    publishBannerBeforeAddition: true,
                                                },
                                                () => {
                                                    this.addPromo();
                                                }
                                            );
                                        }}
                                        style={{
                                            width: "150px",
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#fec708",
                                            color: "#FFFFFF",
                                            // backgroundColor: this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0 ? '#fec708' : '#E8E8E8',
                                            //color: this.state.promoType !== "" && this.state.promoTitle !== "" && this.state.promoDescription !== "" && this.state.promotionStartDate != null && this.state.promoOuterImage.length > 0 && this.state.promoInnerImage.length > 0 ? '#FFFFFF' : '#747474'
                                        }}>
                                        Publish
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    )}

                    {(this.state.showContent || !this.state.isPromoBuffer) && this.state.type === "flyer" && (
                        <PromoFlyer
                            promoName={this.state.promoName}
                            fetchInitialData={this.props.fetchInitialData}
                            bannerPromoData={
                                this.state.isPromoBuffer ? this.getNewPromoFlyerObj() : this.props.bannerPromoData
                            }
                            sectionUuid={this.props.bannerData.uuid}
                            closeFlyerPromoModal={this.props.closeFlyerPromoModal}
                            setPromoBufferFalse={this.setPromoBufferFalse}
                            createPromoState={this.state.createPromoState}
                            updateNewDataInParent={this.props.updateNewDataInParent}
                            convertDateBeforeSending={this.props.convertDateBeforeSending}
                            flyerlogo={flyer}
                            handleclosemodal={this.props.handleclosemodal}
                        />
                    )}
                    <Modal
                        visible={this.state.isDeleteModalActive}
                        footer={null}
                        onCancel={this.closeDeleteModal}
                        destroyOnClose={true}
                        maskClosable={false}
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
                        }}
                        bodyStyle={{
                            background: "#fff",
                            borderRadius: "10px",
                        }}
                        title={null}>
                        <Row className='modal-row'>
                            <Row>
                                <Icon
                                    type='delete'
                                    style={{
                                        color: "#181818",
                                        fontSize: "24px",
                                        marginRight: "16px",
                                    }}
                                />
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                    }}>
                                    Delete item
                                </Text>
                            </Row>
                            {/*<p>Are you sure you want to delete this Promotion?</p>*/}
                            <Row style={{ marginTop: "24px" }}>
                                <Col span={24}>
                                    <Text>Are you sure you want to delete this Promotion?</Text>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={18}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            boxShadow: "none",
                                            borderRadius: "20px",
                                            border: "none",
                                            backgroundColor: "#FFFFFF",
                                            color: "#181818",
                                        }}
                                        onClick={this.closeDeleteModal}>
                                        Cancel
                                    </Button>
                                </Col>

                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={6}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#C91713",
                                            color: "#FFFFFF",
                                        }}
                                        onClick={() => {
                                            this.closeDeleteModal();
                                            this.props.closePromoModal(this.getUpdatedPromoObj());
                                        }}>
                                        Delete
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Modal>
                </>
            );
        } else {
            return <Spin></Spin>;
        }
    }
}

const mapStateToProps = ({ dealsHubAdmin }) => {
    return {
        dealsHubAdmin,
    };
};
export default connect(mapStateToProps, {
    handleUpdate,
    deleteBanner,
    publishBanner,
    unpublishBanner,
    bannerPromoUpdation,
    bannerPromoDeletion,
    addBannerPromo,
    publishPromo,
    unpublishPromo,
})(GenericBannerModalContent);
